import store from '@/store';
import moduleService from '@/configuration/module-service';
import i18n from '../../language/i18n';

var routerWindowService = (function() {

  function _handleRedirectInWindow (currentRouteObj) {

    const windowIdentifier = _getWindowIdentifier(currentRouteObj);
    if (windowIdentifier == undefined) { return }

    const windowData = _getWindowData(windowIdentifier);

    const {
      isUnusualForwarding,
      butForwardingIsIntentional,
      isBrowserBackClicked
    } = _getFlags(windowData);

    if (isUnusualForwarding && butForwardingIsIntentional) {
      _handleUnusulButIntentionalForwarding(windowIdentifier);
    } else if (isUnusualForwarding && isBrowserBackClicked) {
      _handleUnusulForwardingWithBrowserAction(windowIdentifier);
    } else if (isUnusualForwarding) {
      _handleUnusulForwarding(windowIdentifier);
    }

    _handleWindowData(windowData);
  }

  /**************************************
   * ### HANDLERS ###
   ************************************/
  function _handleUnusulButIntentionalForwarding (windowIdentifier) {
    _addCurrentRoutingHistoryToWindowData(windowIdentifier);
    store.commit('routingHistory/setIntentionalUnusualForwarding', false);
  }

  function _handleUnusulForwardingWithBrowserAction (windowIdentifier) {
    _addCurrentRoutingHistoryToWindowData(windowIdentifier);
    store.dispatch('routingHistory/resetRoutingHistoryStack');
    store.dispatch('routingHistory/ignoreNextRoutingObject', false);
  }

  function _handleUnusulForwarding (windowIdentifier) {
    _addCurrentRoutingHistoryToWindowData(windowIdentifier);
  }

  function _handleWindowData(windowData) {
    if (windowData != undefined && windowData.isDirty) {
      store.dispatch('globalSnackbarStore/showSnackbarWithMessage', {
        message: i18n.t('Utility.unsavedChanges')
      });
    }
  }

  /**************************************
   * ### HELPERS ###
   ************************************/
  function _getWindowIdentifier (currentRouteObj) {
    const windowIdentifierType = moduleService.findModuleByModuleId(
      currentRouteObj.meta.moduleId
    )?.windowIdentifierType;

    return { type: windowIdentifierType, id: currentRouteObj.params.id };
  }

  function _getWindowData (windowIdentifier) {
    return store.getters['activeWindows/getWindowData'](windowIdentifier);
  }

  function _getFlags (windowData) {
    const isUnusualForwarding = windowData !== undefined;
    const butForwardingIsIntentional = store.getters['routingHistory/getIntentionalUnusualForwarding'];
    const isBrowserBackClicked = store.getters['routingHistory/getBrowserBackClicked'];

    return { isUnusualForwarding, butForwardingIsIntentional, isBrowserBackClicked }
  }

  function _addCurrentRoutingHistoryToWindowData (windowIdentifier) {
    const routingHistory = store.getters['routingHistory/getCurrentRoutingHistory'];
    store.commit('activeWindows/addRoutingHistory', {...windowIdentifier, routingHistory });
  }

  return {
    handleRedirectInWindow(currentRouteObj) {
      return _handleRedirectInWindow(currentRouteObj);
    }
  }

})();

export default routerWindowService;
